import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Drive from './pages/Drive';
import DropPage from './pages/DropPage';
import ResetPassword from './pages/ResetPassword';
import { Logo } from './components/ui';
import { colors, type } from './theme';

export default function App() {
  const { session, loading } = useAuth();

  if (loading) {
    return (
      <div style={s.loadingScreen}>
        <Logo variant="stacked" size={56} />
        <div className="mc-pulse" style={s.loadingText}>Loading</div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/drop/:token" element={<DropPage />} />
      <Route path="/reset" element={<ResetPassword />} />

      {/* Auth-gated routes */}
      {session ? (
        <>
          <Route path="/" element={<Drive />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      )}
    </Routes>
  );
}

const s = {
  loadingScreen: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    gap: '20px',
    background: colors.bg,
  },
  loadingText: {
    fontSize: type.md,
    color: colors.textMuted,
  },
};
